import React from 'react';
import logoImage from '../logo512.png';

const UnsupportedEnvironment = ({ setStep, hospitalInfo }) => {
  return (
    <div className="App">
      <div className="container mx-auto" style={{ paddingTop: '30px' }}>
        {/* ロゴとタイトル部分 */}
        <div className="title-container text-center cursor-pointer flex items-center justify-center mb-6">
          <img 
            src={logoImage}
            alt="Logo" 
            className="logo mr-2 cursor-pointer"
            style={{ 
              width: '50px', 
              height: 'auto',
              verticalAlign: 'middle'
            }}
            onClick={(e) => {
              e.stopPropagation();
              window.open('https://curelity.co.jp/', '_blank');
            }}
          />
          <h2 className="common-title mb-0 title-text" style={{ verticalAlign: 'middle', lineHeight: '1.2' }}>
            ほねなび
          </h2>
        </div>

        {/* メインコンテンツ */}
        <div className="p-4 bg-blue-100 rounded-lg mt-4">
          <div className="flex justify-center">
            <div className="flex flex-col items-center text-center space-y-2">
              <h1 className="font-bold text-lg mb-4">
                申し訳ございません。<br />
                お使いの機器はこのチェックに対応しておりません。<br />
                お手数ですが、受付にお声がけください。
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsupportedEnvironment; 